// extracted by mini-css-extract-plugin
export default {"AssignUsersWrapper":"AssignUsersWrapper---nvrFh"};